var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2628 13.0374C9.20182 11.7677 8.4402 10.3842 7.9751 9.00827C7.87666 8.71733 7.97872 8.39615 8.21422 8.19938L9.10293 7.4577C9.83111 6.84924 9.91578 5.90402 9.38439 5.26808L8.31981 3.99403C7.6116 3.14647 6.35065 3.03352 5.50308 3.74174L4.79552 4.33297C3.99137 5.00491 3.58823 6.04208 3.69287 7.11569C3.95179 9.76235 5.2085 12.7474 7.42925 15.4051C9.65 18.0628 12.3642 19.83 14.9227 20.5551C15.9606 20.8489 17.0529 20.6365 17.8571 19.9645L18.5636 19.3742C19.4111 18.666 19.5241 17.4051 18.8158 16.5575L17.7522 15.2845C17.2208 14.6486 16.2746 14.5638 15.6396 15.0953L14.6596 15.9151C14.4241 16.1119 14.0899 16.1553 13.8211 16.0067C12.5497 15.3035 11.3237 14.3071 10.2628 13.0374Z",
    stroke: "#2184D1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.f100ca5498c5a76a571bb5c10c1392f3.svg";
export { ForwardRef as ReactComponent };